import { create } from "zustand"

export type ItemSortField = "due_date" | "next_follow_up_at" | "name"

interface ItemFilterState {
  // Search
  searchString: string
  setSearchString: (search: string) => void

  // Priority filter
  priority: number | null
  setPriority: (priority: number | null) => void

  // Sorting
  sortBy: ItemSortField
  sortOrder: "asc" | "desc"
  setSortBy: (field: ItemSortField) => void
  setSortOrder: (order: "asc" | "desc") => void

  // Toggle filters
  showOverdue: boolean
  setShowOverdue: (show: boolean) => void

  showClientAction: boolean
  setShowClientAction: (show: boolean) => void

  showMissedFollowUp: boolean
  setShowMissedFollowUp: (show: boolean) => void

  showHasComment: boolean
  setShowHasComment: (show: boolean) => void

  showMyItems: boolean
  setShowMyItems: (show: boolean) => void

  // Reset filters
  resetFilters: () => void
}

const initialState = {
  searchString: "",
  priority: null,
  sortBy: "due_date" as ItemSortField,
  sortOrder: "asc" as const,
  showOverdue: false,
  showClientAction: false,
  showMissedFollowUp: false,
  showHasComment: false,
  showMyItems: false,
}

export const useItemFilterStore = create<ItemFilterState>()((set) => ({
  ...initialState,

  setSearchString: (search) => set({ searchString: search }),
  setPriority: (priority) => set({ priority }),
  setSortBy: (field) => set({ sortBy: field }),
  setSortOrder: (order) => set({ sortOrder: order }),
  setShowOverdue: (show) => set({ showOverdue: show }),
  setShowClientAction: (show) => set({ showClientAction: show }),
  setShowMissedFollowUp: (show) => set({ showMissedFollowUp: show }),
  setShowHasComment: (show) => set({ showHasComment: show }),
  setShowMyItems: (show) => set({ showMyItems: show }),
  resetFilters: () => set(initialState),
}))
